import React from "react";

export default function HomeWelcome({ name }) {
  return (
    <section className="p2-home-welcome">
      <p className="p2-home-welcome-kicker">
        Mirë se erdhe në MikDok
      </p>
      <h1 className="p2-home-welcome-title">
        Përshëndetje{ name ? `, ${name}` : "" } 👋
      </h1>
      <p className="p2-home-welcome-text">
        Si po ndihesh sot? Këtu mund të gjesh mjekun e duhur, të shohësh
        takimet dhe të kujdesesh për shëndetin tënd me qetësi.
      </p>
    </section>
  );
}
